/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { TooltipHost, TooltipOverflowMode, DirectionalHint } from '@bingads-webui-react/fabric-control';
import {
  recommendationInProductUpdateConfigs,
} from '@bingads-webui-campaign/recommendation-core';
import { judgeWhetherUserFirstViewNotificationBanner,
  isShowNotificationBannerInTargetRecommendations,
  recordUserFirstViewTimeOfNotificationBanner,
} from './utils';

export class InProdUpdateNotificationBanner extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    preferencesService: PropTypes.objectOf(PropTypes.any),
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    additionalArgs: PropTypes.objectOf(PropTypes.any),
  };

  static defaultProps = {
    preferencesService: null,
    additionalArgs: {},
  };

  render() {
    const {
      type, preferencesService, i18n, additionalArgs,
    } = this.props;
    if (preferencesService &&
       judgeWhetherUserFirstViewNotificationBanner(preferencesService, type)) {
      recordUserFirstViewTimeOfNotificationBanner(preferencesService, type);
    }
    const config = recommendationInProductUpdateConfigs[type];

    let notification = null;
    if (config) {
      if (config.needAdditionalArgs === true) {
        if (!_.isEmpty(additionalArgs)) {
          notification = i18n.getString(config.notification, additionalArgs);
        }
      } else {
        notification = i18n.getString(config.notification);
      }
    }

    return (
      <div className="summary-notification">
        { preferencesService && config && notification &&
         isShowNotificationBannerInTargetRecommendations(preferencesService, type) &&
         <div className="recommendation-notification-container">
           <div className="recommendation-notification-text">
             <TooltipHost
               content={notification}
               overflowMode={TooltipOverflowMode.Parent}
               directionalHint={DirectionalHint.bottomCenter}
             >
               {notification}
             </TooltipHost>
           </div>
           {config.helpTopic &&
           <div className="recommendation-notification-help">
             <HelpPopup
               topic={config.helpTopic}
             />
           </div>
           }
         </div>
        }
      </div>
    );
  }
}
